// extracted by mini-css-extract-plugin
export default {"dablArr":"Table_dablArr__dZN5Q"};